export const mobileWidth = 768;
